import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import {
  IcUsers, IcUserPlus, IcPdf, IcAt, IcExcel,
  IcUserEdit, IcIdCard, IcMap, IcHandshake, IcFileInvoice,
  IcSave, IcEdit, IcDollar, IcXCircle, IcCheckCircle,
  IcMinus, IcPlus, FaIcon,
} from "../../Icons";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  FormGroup,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { pdfHeader, pdfFooter, pdfTableStyles } from "../../../pdfUtils";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../Baja";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";

function ListadoClientes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_CUENTAS_CLIENTES = process.env.REACT_APP_URL_CUENTAS_CLIENTES;
 
  const [clientes, setClientes] = useState([]);
  const [mailTo, setMailTo] = useState("");
  const [idEdit, setIdEdit] = useState("");
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("");
  const [RFC, setRFC] = useState("");
  const [calle, setCalle] = useState("");
  const [numero_ext, setNumeroExt] = useState("");
  const [numero_int, setNumeroInt] = useState("");
  const [delegacion, setDelegacion] = useState("");
  const [estado, setEstado] = useState("");
  const [pais, setPais] = useState("");
  const [cp, setCP] = useState("");
  const [colonia, setColonia] = useState("");
  const [contacto, setContacto] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [emailViejo, setEmailViejo] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [ultimo_pago, setUltimoPago] = useState("");

  const [lider, setLider] = useState("NA");
  const [ramo, setRamo] = useState("");
  const [produccion, setProduccion] = useState("");
  const [mes, setMes] = useState("");
  const [anio, setAnio] = useState("");
  const [copiadoDe, setCopiadoDe] = useState("");

  const [forma_pago, setFormaPago] = useState("");
  const [plazo, setPlazo] = useState("");
  const [regFiscal, setRegFiscal] = useState("");
  const [usoCFDI, setusoCFDI] = useState("");
  const [formaPagoSAT, setFormaPagoSAT] = useState("");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("");
  const [fiscal, setFiscal] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [activo, setActivo] = useState("Si");
  const [selectedEmpresa, setSelectedEmpresa] = useState("ExceptoSistemify");
  const [selectedEmpresaEdit, setSelectedEmpresaEdit] = useState("");

  const [cuentas, setCuentas] = useState([]);
  const [idClienteCuenta, setIdClienteCuenta] = useState("");
  const [modalCuenta, setModalCuenta] = useState(false);
  const toggleCuenta = () => setModalCuenta(!modalCuenta);
  const [refreshCount,    setRefreshCount]    = useState(0);
  const [modalCreate,     setModalCreate]     = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);
  const [cNombre,         setCNombre]         = useState("");
  const [cRazonSocial,    setCRazonSocial]    = useState("");
  const [cRFC,            setCRFC]            = useState("NA");
  const [cContacto,       setCContacto]       = useState("");
  const [cEmail,          setCEmail]          = useState("");
  const [cTelefono,       setCTelefono]       = useState("");
  const [cObservaciones,  setCObservaciones]  = useState("");
  const [cLider,          setCLider]          = useState("NA");
  const [cCopiadoDe,      setCCopiadoDe]      = useState("");
  const [cEmpresa,        setCEmpresa]        = useState("Lynqro");
  const [cRamo,           setCRamo]           = useState("Sistema");
  const [cFormaPago,      setCFormaPago]      = useState("PorDefinir");
  const [cPlazo,          setCPlazo]          = useState("0");
  const [cMes,            setCMes]            = useState("");
  const [cAnio,           setCAnio]           = useState("");

  const [inputFieldsCuentas, setInputFieldsCuentas] = useState([
    {
      id: uuidv4(),
      banco: "",
      cuenta:"",
      rfc:"",
    },
  ]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

 
  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const allClientes = response.data;
        const arrayTabla = allClientes
          .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
          .map((a) => ({
            _id: a._id,
            activo: a.is_active,
            empresa: a.empresa,
            nombre_comercial: a.nombre_comercial,
            razon_social: a.razon_social,
            RFC: a.RFC,
            calle: a.calle,
            numero_ext: a.numero_ext,
            numero_int: a.numero_int,
            delegacion: a.delegacion,
            estado: a.estado,
            pais: a.pais,
            cp: a.cp,
            colonia: a.colonia,
            ciudad: a.ciudad,
            contacto: a.contacto,
            telefono: a.telefono,
            email: a.email,
            observaciones: a.observaciones,
            lider: a.lider,
            ramo: a.ramo,
            produccion: a.produccion,
            mes: a.mes,
            anio: a.anio,
            copiadoDe: a.copiadoDe,
            forma_pago: a.forma_pago,
            plazo: a.plazo,
            regFiscal: a.regFiscal,
            usoCFDI: a.usoCFDI,
            formaPagoSAT: a.formaPagoSAT,
            condicionesPagoSAT: a.condicionesPagoSAT,
            metodoPagoSAT: a.metodoPagoSAT,
            fiscal: a.fiscal,
          }));
        setClientes(allClientes);
        setComments(arrayTabla);
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Error al cargar clientes" });
      });
  }, [URL_CLIENTES, refreshCount]); // eslint-disable-line

  function saveCliente() {
    if (!cNombre || !cContacto || !cEmail) {
      return Swal.fire({ icon: "warning", title: "Nombre, contacto y email son requeridos" });
    }
    axios.post(URL_CLIENTES, {
      nombre_comercial: cNombre, razon_social: cRazonSocial || cNombre, RFC: cRFC || "NA",
      calle: "NA", numero_ext: "NA", numero_int: "NA", delegacion: "NA",
      estado: "NA", pais: "Mexico", cp: "NA", colonia: "NA", ciudad: "NA",
      contacto: cContacto, telefono: cTelefono || "0", email: cEmail,
      observaciones: cObservaciones || "NA", lider: cLider || "NA", ramo: cRamo,
      produccion: "NA", mes: cMes, anio: cAnio, copiadoDe: cCopiadoDe || "",
      forma_pago: cFormaPago, plazo: cPlazo,
      regFiscal: "612", usoCFDI: "G03", formaPagoSAT: "99",
      condicionesPagoSAT: "NA", metodoPagoSAT: "PPD", fiscal: "No",
      empresa: cEmpresa, ultimo_pago: "", cargos: 0, abonos: 0, saldo: 0,
    }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then(() => {
        setCNombre(""); setCRazonSocial(""); setCRFC("NA"); setCContacto("");
        setCEmail(""); setCTelefono(""); setCObservaciones(""); setCLider("NA"); setCCopiadoDe("");
        setCEmpresa("Lynqro"); setCRamo("Sistema"); setCFormaPago("PorDefinir"); setCPlazo("0");
        setCMes(""); setCAnio("");
        setModalCreate(false);
        setRefreshCount((p) => p + 1);
        Swal.fire({ icon: "success", title: "Cliente creado", timer: 1500, showConfirmButton: false });
      })
      .catch(() => Swal.fire({ icon: "error", title: "Error al guardar" }));
  }

  const ListaClientes = clientes.sort((a, b) =>
    a.nombre_comercial > b.nombre_comercial ? 1 : -1
  );

function PDFTabla() {
  const data = ListaClientes.map((a) => {
    const coincideActivo = activo == 0 || activo == a.is_active;

    const coincideEmpresa =
      selectedEmpresa === "" ||
      (selectedEmpresa === "ExceptoSistemify"
        ? a.empresa !== "Sistemify"
        : selectedEmpresa === a.empresa);

    if (coincideActivo && coincideEmpresa) {
      return [a.nombre_comercial, a.telefono, a.email];
    }

    return null;
  });

  const dataPDFLimpia = Object.values(data).filter((el) => el != null);

  const doc = new jsPDF("landscape");
  const startY = pdfHeader(doc, "Listado de Clientes");

  doc.autoTable({
    ...pdfTableStyles(),
    head: [["Nombre", "Telefono", "Mail"]],
    body: dataPDFLimpia,
    startY,
  });

  pdfFooter(doc);
  doc.save(`Clientes.pdf`);
}

function excel() {
  const dataExcel = ListaClientes.map((a) => {
    const coincideActivo = activo == 0 || activo == a.is_active;

    const coincideEmpresa =
      selectedEmpresa === "" ||
      (selectedEmpresa === "ExceptoSistemify"
        ? a.empresa !== "Sistemify"
        : selectedEmpresa === a.empresa);

    if (coincideActivo && coincideEmpresa) {
      return {
        Nombre: a.nombre_comercial,
        Telefono: a.telefono,
        Mail: a.email,
      };
    }

    return null;
  });

  const dataExcelLimpia = Object.values(dataExcel).filter((el) => el != null);

  var option = {};
  option.fileName = "ListadoClientes";

  option.datas = [
    {
      sheetData: dataExcelLimpia,
      sheetName: "ListadoClientes",
      sheetFilter: ["Nombre", "Telefono", "Mail"],
      sheetHeader: ["Nombre", "Telefono", "Mail"],
    },
  ];

  var toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}


  function enviaMail() {
    const data = ListaClientes.map((a) => {
      if (
        (activo == 0 || activo == a.is_active)
      ) {
        return [
          a.nombre_comercial,
          a.telefono,
          a.email,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    const startY = pdfHeader(doc, "Listado de Clientes");
    doc.autoTable({
      ...pdfTableStyles(),
      head: [["Nombre", "Telefono", "Mail"]],
      body: dataPDFLimpia,
      startY,
    });
    pdfFooter(doc);
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Clientes",
          email: mailTo,
          fileName: "ListadoClientes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Clientes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
      });
  }

  function jalaInfo(
    idEdit,
    nombre_comercial,
    razon_social,
    RFC,
    calle,
    numero_ext,
    numero_int,
    delegacion,
    estado,
    pais,
    cp,
    colonia,
    ciudad,
    contacto,
    telefono,
    email,
    observaciones,
    lider,
    ramo,
    empresa,
    produccion,
    mes,
    anio,
    copiadoDe,
    forma_pago,
    plazo,
    usoCFDI,
    regFiscal,
    formaPagoSAT,
    metodoPagoSAT,
    condicionesPagoSAT,
    fiscal
  ) {
    setIdEdit(idEdit)
    setNombreComercial(nombre_comercial)
    setRazonSocial(razon_social)
    setRFC(RFC)
    setCalle(calle)
    setNumeroExt(numero_ext)
    setNumeroInt(numero_int)
    setDelegacion(delegacion)
    setEstado(estado)
    setPais(pais)
    setCP(cp)
    setColonia(colonia)
    setCiudad(ciudad)
    setContacto(contacto)
    setTelefono(telefono)
    setEmail(email)
    setObservaciones(observaciones)
    setLider(lider)
    setRamo(ramo)
    setSelectedEmpresaEdit(empresa)
    setProduccion(produccion)
    setMes(mes)
    setAnio(anio)
    setCopiadoDe(copiadoDe)
    setFormaPago(forma_pago)
    setPlazo(plazo)
    setusoCFDI(usoCFDI)
    setRegFiscal(regFiscal)
    setFormaPagoSAT(formaPagoSAT)
    setMetodoPagoSAT(metodoPagoSAT)
    setCondicionesPagoSAT(condicionesPagoSAT)
    setFiscal(fiscal)
    toggleEdit();
  }

  

  function editClientes(event) {
    event.preventDefault();
    const URL_CLIENTES_EDIT = `${process.env.REACT_APP_URL_CLIENTES}/${idEdit}`;
        axios.patch(
          URL_CLIENTES_EDIT,
          {
            nombre_comercial,
            razon_social,
            RFC,
            calle,
            numero_ext,
            numero_int,
            delegacion,
            estado,
            pais,
            cp,
            colonia,
            ciudad,
            contacto,
            telefono,
            email,
            observaciones,
            lider,
            ramo,
            empresa: selectedEmpresaEdit,
            produccion,
            mes,
            anio,
            copiadoDe,
            forma_pago,
            plazo,
            usoCFDI,
            regFiscal,
            formaPagoSAT,
            metodoPagoSAT,
            condicionesPagoSAT,
            fiscal
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cliente",
            detalle: `${nombre_comercial}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  }


  const headers = [
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Contacto", field: "contacto", sortable: true },
    { name: "Telefono", field: "telefono", sortable: false },
    { name: "Email", field: "email", sortable: true },
    { name: "Ramo", field: "ramo", sortable: true },
    { name: "Produccion", field: "produccion", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const summaryStats = useMemo(() => {
    const activos   = comments.filter((c) => c.activo === "Si");
    const inactivos = comments.filter((c) => c.activo !== "Si" && c.empresa === "Lynqro");
    return {
      total:    comments.length,
      activos:  activos.length,
      inactivos: inactivos.length,
      lynqro:   comments.filter((c) => c.empresa === "Lynqro").length,
    };
  }, [comments]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre_comercial.toLowerCase().includes(search.toLowerCase()) ||
          comment.email.toLowerCase().includes(search.toLowerCase()) ||
          comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
          comment.contacto.toLowerCase().includes(search.toLowerCase())
          );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo));
    }
   if (selectedEmpresa === "ExceptoSistemify") {
  computedComments = computedComments.filter(
    (e) => e.empresa !== "Sistemify"
  );
} else if (selectedEmpresa) {
  computedComments = computedComments.filter(
    (e) => e.empresa === selectedEmpresa
  );
}


    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    activo,
    selectedEmpresa
  ]);

  
function cue(id, nombre_comercial) {
  setIdClienteCuenta(id);
  setNombreComercial(nombre_comercial);
  axios
    .get(`${URL_CUENTAS_CLIENTES}/cliente/${id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allCuentas = res.data;
      setCuentas(allCuentas);
    })
    .catch((err) => {
    });
  toggleCuenta();
}

const handleChangeInputCuentasExistentes = (id, event) => {
  const newCuentas = cuentas.map((i) => {
    if (id === i._id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setCuentas(newCuentas);
};

const handleChangeInputCuentas = (id, event) => {
  const newInputFieldsCuentas = inputFieldsCuentas.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFieldsCuentas(newInputFieldsCuentas);
};

function saveCuenta() {
  let totalCuen = cuentas.length + inputFieldsCuentas.length;
  cuentas.map((a) => {
    if (a.cuenta != "") {
      axios
        .patch(
          `${URL_CUENTAS_CLIENTES}/${a._id}`,
          {
            cuenta: a.cuenta,
            banco: a.banco,
            rfc: a.rfc,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalCuen = totalCuen - 1;
          if (totalCuen == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Cuentas Clientes",
                detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
        });
    } else {
      totalCuen = totalCuen - 1
      if (totalCuen == 0) {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cuenta Clientes",
            detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  });

  // agregar inputFields
  inputFieldsCuentas.map((a) => {
    if (a.cuenta != "") {
      axios
        .post(
          `${URL_CUENTAS_CLIENTES}`,
          {
            clientes: idClienteCuenta,
            cuenta: a.cuenta,
            banco: a.banco,
            rfc: a.rfc,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalCuen = totalCuen - 1;
          if (totalCuen == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Cuenta Clientes",
                detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
        });
    } else {
      totalCuen = totalCuen - 1
      if (totalCuen == 0) {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cuenta Clientes",
            detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  });
}

const handleAddFieldsCuentas = () => {
  setInputFieldsCuentas([
    ...inputFieldsCuentas,
    {
      id: uuidv4(),
      banco: "",
      cuenta:"",
      rfc:"",
    },
  ]);
};

const handleRemoveFieldsCuentas = (id) => {
  const values = [...inputFieldsCuentas];
  values.splice(
    values.findIndex((value) => value.id === id),
    1
  );
  setInputFieldsCuentas(values);
};

function altaCuenta(id) {
  axios
    .patch(
      `${URL_CUENTAS_CLIENTES}/${id}`,
      {
        is_active: "Si"
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }
    )
    .then((data) => {
          Swal.fire("Good job!", "Creado con exito", "success");

          const newCuentas = cuentas.map((i) => {
            if (id === i._id) {
              i.is_active = "Si";
            }
            return i;
          });
          setCuentas(newCuentas);
       
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    });
}

function bajaCuenta(id) {
axios
.patch(
`${URL_CUENTAS_CLIENTES}/${id}`,
{
is_active: "No"
},
{
headers: {
  Authorization: `Bearer: ${localStorage.getItem(
    "app_token"
  )}`,
},
}
)
.then((data) => {
  Swal.fire("Good job!", "Creado con exito", "success");
  const newCuentas = cuentas.map((i) => {
    if (id === i._id) {
      i.is_active = "No";
    }
    return i;
  });
  setCuentas(newCuentas);
})
.catch((error) => {
Swal.fire({
icon: "error",
title: "Oops...",
text: "Something went wrong!",
// footer: `${error.response.data}`,
});
});
}
  
  return (
    <>
      <Header />
      <br />
      <br />
      {/* {user.menu_clientes ? ( */}
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcUsers style={{ marginRight: 8, color: "#8b5cf6" }} />
                Clientes
              </h3>
              <p className="page-subtitle">Directorio de clientes del sistema</p>
            </div>
            <div className="page-actions">
              <Button size="sm" color="success" onClick={toggleCreate}>
                <IcUserPlus style={{ marginRight: 6 }} />
                Nuevo Cliente
              </Button>
              <ButtonGroup>
                <Button size="sm" color="danger" onClick={PDFTabla}>PDF <IcPdf /></Button>
                <Button size="sm" color="info" onClick={toggleMail}>eMail <IcAt /></Button>
                <Button size="sm" color="primary" onClick={excel}>Excel <IcExcel /></Button>
              </ButtonGroup>
            </div>
          </div>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Clientes</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          {/* ── Summary cards ──────────────────────────────────────────── */}
          <div className="row mb-3 mt-1">
            {[
              { label: "Total clientes",  value: summaryStats.total,    sub: "En el sistema",               icon: "fas fa-users",         color: "#8b5cf6", bg: "#f5f3ff" },
              { label: "Activos",         value: summaryStats.activos,  sub: "Clientes vigentes",           icon: "fas fa-user-check",    color: "#10b981", bg: "#f0fdf4" },
              { label: "Inactivos Lynqro",value: summaryStats.inactivos,sub: "Sin actividad · Lynqro",       icon: "fas fa-user-slash",    color: "#ef4444", bg: "#fff1f2" },
              { label: "Total Lynqro",    value: summaryStats.lynqro,   sub: "Empresa Lynqro",              icon: "fas fa-building",      color: "#3b82f6", bg: "#eff6ff" },
            ].map((card, i) => (
              <div key={i} className="col-6 col-md-3 mb-2">
                <div style={{ background: "#fff", borderRadius: 14, padding: "16px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", borderTop: `3px solid ${card.color}`, display: "flex", alignItems: "center", gap: 14, height: "100%" }}>
                  <div style={{ width: 46, height: 46, borderRadius: 12, background: card.bg, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FaIcon cls={card.icon} size={20} style={{ color: card.color }} />
                  </div>
                  <div>
                    <div style={{ fontSize: "1.55rem", fontWeight: 800, color: "#0f172a", lineHeight: 1 }}>{card.value}</div>
                    <div style={{ fontSize: "0.67rem", fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 4 }}>{card.label}</div>
                    <div style={{ fontSize: "0.72rem", color: card.color, fontWeight: 600, marginTop: 2 }}>{card.sub}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <div className="filter-bar">
            <div>
              <Label>Empresa</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 160 }}
                value={selectedEmpresa}
                required
                onChange={(e) => {
                  setSelectedEmpresa(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="ExceptoSistemify">Excepto Sistemify</option>
                <option value="Lynqro">Lynqro</option>
                <option value="Lynqro 2">Lynqro 2</option>
                <option value="Sistemify">Sistemify</option>
              </Input>
            </div>

            <div>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                style={{ minWidth: 130 }}
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </div>
          </div>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => (
                <tr key={p._id}>
                  <td>{p.nombre_comercial}</td>
                  <td>{p.empresa}</td>
                  <td>{p.contacto}</td>
                  <td>{p.telefono}</td>
                  <td>{p.email}</td>
                  <td>{p.ramo}</td>
                  <td>{p.produccion}</td>
                  <td>
                    <div>
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => jalaInfo(
                          p._id, p.nombre_comercial, p.razon_social, p.RFC,
                          p.calle, p.numero_ext, p.numero_int, p.delegacion,
                          p.estado, p.pais, p.cp, p.colonia, p.ciudad,
                          p.contacto, p.telefono, p.email, p.observaciones,
                          p.lider, p.ramo, p.empresa, p.produccion, p.mes, p.anio, p.copiadoDe,
                          p.forma_pago, p.plazo, p.usoCFDI, p.regFiscal,
                          p.formaPagoSAT, p.metodoPagoSAT, p.condicionesPagoSAT, p.fiscal,
                        )}
                      >
                        <IcEdit />
                      </Button>
                      <Button
                        color="info"
                        size="sm"
                        onClick={() => cue(p._id, p.nombre_comercial)}
                      >
                        <IcDollar />
                      </Button>
                      <Baja
                        idStatus={p._id}
                        is_active={p.activo}
                        URL_BAJA={process.env.REACT_APP_URL_CLIENTES}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      {/* ) : undefined} */}
      <br />

      <Modal size="xl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            <IcUserEdit style={{ marginRight: 8, color: "#8b5cf6" }} />
            Editar Cliente — {nombre_comercial}
          </h4>
        </ModalHeader>
        <ModalBody>

          {/* Section 1 — Información Principal */}
          <div className="form-section">
            <div className="form-section-header">
              <IcIdCard />
              <span className="form-section-title">Información Principal</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={3}>
                  <FormGroup>
                    <Label>Contacto</Label>
                    <Input
                      type="text"
                      placeholder="Contacto"
                      value={contacto}
                      required
                      onChange={(e) => { setContacto(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Nombre Comercial</Label>
                    <Input
                      type="text"
                      placeholder="Nombre Comercial"
                      value={nombre_comercial}
                      required
                      onChange={(e) => { setNombreComercial(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Razón Social</Label>
                    <Input
                      type="text"
                      placeholder="Razon Social"
                      value={razon_social}
                      required
                      onChange={(e) => { setRazonSocial(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>RFC</Label>
                    <Input
                      type="text"
                      placeholder="RFC"
                      value={RFC}
                      required
                      onChange={(e) => { setRFC(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <FormGroup>
                    <Label>Teléfono</Label>
                    <Input
                      type="text"
                      placeholder="Telefono"
                      value={telefono}
                      required
                      onChange={(e) => { setTelefono(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Email</Label>
                    <Input
                      type="email"
                      placeholder="Email"
                      value={email}
                      required
                      onChange={(e) => { setEmail(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Observaciones</Label>
                    <Input
                      type="text"
                      placeholder="Observaciones"
                      value={observaciones}
                      required
                      onChange={(e) => { setObservaciones(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          {/* Section 2 — Dirección */}
          <div className="form-section">
            <div className="form-section-header">
              <IcMap />
              <span className="form-section-title">Dirección</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={5}>
                  <FormGroup>
                    <Label>Calle</Label>
                    <Input
                      type="text"
                      placeholder="Calle"
                      value={calle}
                      required
                      onChange={(e) => { setCalle(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>No. Ext</Label>
                    <Input
                      type="text"
                      placeholder="No. Ext"
                      value={numero_ext}
                      required
                      onChange={(e) => { setNumeroExt(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>No. Int</Label>
                    <Input
                      type="text"
                      placeholder="No. Int"
                      value={numero_int}
                      required
                      onChange={(e) => { setNumeroInt(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>País</Label>
                    <Input
                      type="text"
                      placeholder="Pais"
                      value={pais}
                      required
                      onChange={(e) => { setPais(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <FormGroup>
                    <Label>Estado</Label>
                    <Input
                      type="text"
                      placeholder="Estado"
                      value={estado}
                      required
                      onChange={(e) => { setEstado(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Ciudad</Label>
                    <Input
                      type="text"
                      placeholder="Ciudad"
                      value={ciudad}
                      required
                      onChange={(e) => { setCiudad(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Delegación/Municipio</Label>
                    <Input
                      type="text"
                      placeholder="Delegacion o Municipio"
                      value={delegacion}
                      required
                      onChange={(e) => { setDelegacion(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>Colonia</Label>
                    <Input
                      type="text"
                      placeholder="Colonia"
                      value={colonia}
                      required
                      onChange={(e) => { setColonia(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={1}>
                  <FormGroup>
                    <Label>CP</Label>
                    <Input
                      type="text"
                      placeholder="CP"
                      value={cp}
                      required
                      onChange={(e) => { setCP(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          {/* Section 3 — Datos Comerciales */}
          <div className="form-section">
            <div className="form-section-header">
              <IcHandshake />
              <span className="form-section-title">Datos Comerciales</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={3}>
                  <FormGroup>
                    <Label>Líder</Label>
                    <Input
                      type="text"
                      placeholder="Lider"
                      value={lider}
                      required
                      onChange={(e) => { setLider(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Ramo</Label>
                    <Input
                      type="select"
                      value={ramo}
                      required
                      onChange={(e) => { setRamo(e.target.value); }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Administracion">Administracion</option>
                      <option value="Despacho">Despacho</option>
                      <option value="Donativos">Donativos</option>
                      <option value="Importacion">Importacion</option>
                      <option value="Logistica">Logistica</option>
                      <option value="Market Place">Market Place</option>
                      <option value="Produccion">Produccion</option>
                      <option value="Sistema">Sistema</option>
                      <option value="Telas">Telas</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Copiado De</Label>
                    <Input
                      type="text"
                      placeholder="Copiado de"
                      value={copiadoDe}
                      required
                      onChange={(e) => { setCopiadoDe(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Producción</Label>
                    <Input
                      type="select"
                      value={produccion}
                      required
                      onChange={(e) => { setProduccion(e.target.value); }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <FormGroup>
                    <Label>Mes de Alta</Label>
                    <Input
                      type="select"
                      value={mes}
                      onChange={(e) => { setMes(e.target.value); }}
                    >
                      <option value="">Selecciona</option>
                      {["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio",
                        "Agosto","Septiembre","Octubre","Noviembre","Diciembre"].map((m) => (
                        <option key={m} value={m}>{m}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Año de Alta</Label>
                    <Input
                      type="select"
                      value={anio}
                      onChange={(e) => { setAnio(e.target.value); }}
                    >
                      <option value="">Selecciona</option>
                      {["2022","2023","2024","2025","2026","2027","2028","2029","2030","2031"].map((y) => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <FormGroup>
                    <Label>Forma de Pago</Label>
                    <Input
                      type="select"
                      value={forma_pago}
                      required
                      onChange={(e) => { setFormaPago(e.target.value); }}
                    >
                      <option value="0">Forma de Pago</option>
                      <option value="Efectivo">Efectivo</option>
                      <option value="Deposito">Deposito</option>
                      <option value="Cheque">Cheque</option>
                      <option value="PorDefinir">Por Definir</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Plazo</Label>
                    <Input
                      type="select"
                      value={plazo}
                      required
                      onChange={(e) => { setPlazo(e.target.value); }}
                    >
                      <option value="">Plazo</option>
                      <option value="0">0</option>
                      <option value="30">30</option>
                      <option value="60">60</option>
                      <option value="90">90</option>
                      <option value="120">120</option>
                      <option value="150">150</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Empresa</Label>
                    <Input
                      type="select"
                      value={selectedEmpresaEdit}
                      required
                      onChange={(e) => { setSelectedEmpresaEdit(e.target.value); }}
                    >
                      <option value="Lynqro">Lynqro</option>
                      <option value="Lynqro 2">Lynqro 2</option>
                      <option value="Sistemify">Sistemify</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          {/* Section 4 — Datos Fiscales */}
          <div className="form-section">
            <div className="form-section-header">
              <IcFileInvoice />
              <span className="form-section-title">Datos Fiscales</span>
            </div>
            <div className="form-section-body">
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label>Régimen Fiscal</Label>
                    <Input
                      type="select"
                      value={regFiscal}
                      required
                      onChange={(e) => { setRegFiscal(e.target.value); }}
                    >
                      <option value="">Reg Fiscal</option>
                      <option value="0">0</option>
                      <option value="601">601 General de Ley Personas Morales</option>
                      <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                      <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                      <option value="608">608 Demas Ingresos</option>
                      <option value="612">612 Personas Físicas con Actividades Empresariales y Profesionales</option>
                      <option value="616">616 Sin Obligacion Fiscal</option>
                      <option value="621">621 Incorporacion Fiscal</option>
                      <option value="624">624 Régimen de los Coordinados</option>
                      <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                      <option value="626">626 Regimen simplificado de Confianza</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>Fiscal</Label>
                    <Input
                      type="select"
                      value={fiscal}
                      required
                      onChange={(e) => { setFiscal(e.target.value); }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Uso CFDI</Label>
                    <Input
                      type="select"
                      value={usoCFDI}
                      required
                      onChange={(e) => { setusoCFDI(e.target.value); }}
                    >
                      <option value="">Uso de CDFI</option>
                      <option value="G01">G01 Adquisición de mercancías</option>
                      <option value="G03">G03 Gastos en general</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label>Método Pago SAT</Label>
                    <Input
                      type="select"
                      value={metodoPagoSAT}
                      required
                      onChange={(e) => { setMetodoPagoSAT(e.target.value); }}
                    >
                      <option value="">Selecciona</option>
                      <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
                      <option value="PPD">PPD (Pago en Parcialidades o Diferido)</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Forma Pago Fiscal</Label>
                    <Input
                      type="select"
                      value={formaPagoSAT}
                      required
                      onChange={(e) => { setFormaPagoSAT(e.target.value); }}
                    >
                      <option value="">Selecciona</option>
                      <option value="01"> 01 Efectivo</option>
                      <option value="02"> 02 Cheque nominativo</option>
                      <option value="03"> 03 Transferencia electrónica de fondos</option>
                      <option value="04"> 04 Tarjeta de crédito</option>
                      <option value="05"> 05 Monedero electrónico</option>
                      <option value="06"> 06 Dinero electrónico</option>
                      <option value="08"> 08 Vales de despensa</option>
                      <option value="12"> 12 Dación en pago</option>
                      <option value="13"> 13 Pago por subrogación</option>
                      <option value="14"> 14 Pago por consignación</option>
                      <option value="15"> 15 Condonación</option>
                      <option value="17"> 17 Compensación</option>
                      <option value="23"> 23 Novación</option>
                      <option value="24"> 24 Confusión</option>
                      <option value="25"> 25 Remisión de deuda</option>
                      <option value="26"> 26 Prescripción o caducidad</option>
                      <option value="27"> 27 A satisfacción del acreedor</option>
                      <option value="28"> 28 Tarjeta de débito</option>
                      <option value="29"> 29 Tarjeta de servicios</option>
                      <option value="30"> 30 Aplicación de anticipos</option>
                      <option value="99"> 99 Por definir</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label>Condiciones Pago Fiscal</Label>
                    <Input
                      type="text"
                      value={condicionesPagoSAT}
                      required
                      onChange={(e) => { setCondicionesPagoSAT(e.target.value); }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editClientes}>
            <IcSave style={{ marginRight: 6 }} />
            Guardar Cambios
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xl" isOpen={modalCuenta} toggle={toggleCuenta}>
        <ModalHeader toggle={toggleCuenta}>
          <h4>Cuentas {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
        <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Banco</th>
                      <th>RFC</th>
                      <th>Cuentas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cuentas.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="text"
                            name="banco"
                            value={a.banco}
                            key={a._id}
                            onChange={(e) => {
                              handleChangeInputCuentasExistentes(a._id, e);
                            }}
                          />
                        </td>
                         <td>
                          <Input
                            type="text"
                            name="rfc"
                            value={a.rfc}
                            key={a._id}
                            onChange={(e) => {
                              handleChangeInputCuentasExistentes(a._id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="cuenta"
                            type="text"
                            value={a.cuenta}
                            required
                            // maxLength="4" // Limit to 4 digits
                            // pattern="\d{1,4}" 
                            onChange={(event) => {
                              handleChangeInputCuentasExistentes(a._id, event);
                            }}
                          />
                        </td>
                        <td>
                          {a.is_active == "Si"?(
                            <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={() => bajaCuenta(a._id)}
                            tabindex="-1"
                          >
                            <IcXCircle />
                          </Button>
                          ):(
                            <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={() => altaCuenta(a._id)}
                            tabindex="-1"
                          >
                            <IcCheckCircle />
                          </Button>
                          )}
                         
                        </td>
                      </tr>
                      // </div>
                    ))}

              {inputFieldsCuentas.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="text"
                            name="banco"
                            value={a.banco}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputCuentas(a.id, e);
                            }}
                          />
                        </td>
                         <td>
                          <Input
                            type="text"
                            name="rfc"
                            value={a.rfc}
                            key={a._id}
                            onChange={(e) => {
                              handleChangeInputCuentas(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="cuenta"
                            type="text"
                            value={a.cuenta}
                            required
                            // maxLength="4" // Limit to 4 digits
                            // pattern="\d{1,4}" 
                            onChange={(event) => {
                              handleChangeInputCuentas(a.id, event);
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            disabled={a.length === 1}
                            onClick={() => handleRemoveFieldsCuentas(a.id)}
                            tabindex="-1"
                          >
                            <IcMinus />
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFieldsCuentas}
                            tabindex="-1"
                          >
                            <IcPlus />
                          </Button>
                        </td>
                      </tr>
                      // </div>
                    ))}

                  </tbody>
                  <br />
                </Table>
                <br />
                <Row>
                <Button className="btn btn-success" onClick={saveCuenta}>
                Registrar
              </Button>
                </Row>

        </ModalBody>
      </Modal>
      {/* ── Modal Nuevo Cliente ──────────────────────────────────────── */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          <IcUserPlus style={{ marginRight: 8, color: "#8b5cf6" }} />
          Nuevo Cliente
        </ModalHeader>
        <ModalBody>
          {/* ── Información Principal ─────────────────────────────── */}
          <div style={{ borderLeft: "3px solid #3b82f6", paddingLeft: 10, marginBottom: 14 }}>
            <span style={{ fontSize: "0.7rem", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.07em" }}>
              Información Principal
            </span>
          </div>
          <div className="row">
            <div className="col-md-3">
              <FormGroup>
                <Label>Contacto <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="text" value={cContacto} onChange={(e) => setCContacto(e.target.value)} required />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Nombre Comercial <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="text" value={cNombre} onChange={(e) => setCNombre(e.target.value)} required />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Razón Social</Label>
                <Input bsSize="sm" type="text" value={cRazonSocial} onChange={(e) => setCRazonSocial(e.target.value)} />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>RFC</Label>
                <Input bsSize="sm" type="text" value={cRFC} onChange={(e) => setCRFC(e.target.value)} />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Teléfono</Label>
                <Input bsSize="sm" type="text" value={cTelefono} onChange={(e) => setCTelefono(e.target.value)} />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Email <span style={{ color: "#ef4444" }}>*</span></Label>
                <Input bsSize="sm" type="email" value={cEmail} onChange={(e) => setCEmail(e.target.value)} required />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup>
                <Label>Observaciones</Label>
                <Input bsSize="sm" type="text" value={cObservaciones} onChange={(e) => setCObservaciones(e.target.value)} />
              </FormGroup>
            </div>
          </div>

          {/* ── Datos Comerciales ─────────────────────────────────── */}
          <div style={{ borderLeft: "3px solid #8b5cf6", paddingLeft: 10, marginBottom: 14, marginTop: 8 }}>
            <span style={{ fontSize: "0.7rem", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.07em" }}>
              Datos Comerciales
            </span>
          </div>
          <div className="row">
            <div className="col-md-3">
              <FormGroup>
                <Label>Líder</Label>
                <Input bsSize="sm" type="text" value={cLider} onChange={(e) => setCLider(e.target.value)} />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Ramo</Label>
                <Input type="select" value={cRamo} onChange={(e) => setCRamo(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  {["Administracion","Despacho","Donativos","Importacion","Logistica","Market Place","Produccion","Sistema","Telas"].map((r) => (
                    <option key={r} value={r}>{r}</option>
                  ))}
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Copiado de</Label>
                <Input bsSize="sm" type="text" value={cCopiadoDe} onChange={(e) => setCCopiadoDe(e.target.value)} />
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Empresa</Label>
                <Input type="select" value={cEmpresa} onChange={(e) => setCEmpresa(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="Lynqro">Lynqro</option>
                  <option value="Lynqro 2">Lynqro 2</option>
                  <option value="Sistemify">Sistemify</option>
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Forma de Pago</Label>
                <Input type="select" value={cFormaPago} onChange={(e) => setCFormaPago(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="PorDefinir">Por Definir</option>
                  <option value="Efectivo">Efectivo</option>
                  <option value="Deposito">Depósito</option>
                  <option value="Cheque">Cheque</option>
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Plazo (días)</Label>
                <Input type="select" value={cPlazo} onChange={(e) => setCPlazo(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  {["0","30","60","90","120","150"].map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Mes de Alta</Label>
                <Input type="select" value={cMes} onChange={(e) => setCMes(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="">Selecciona</option>
                  {["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio",
                    "Agosto","Septiembre","Octubre","Noviembre","Diciembre"].map((m) => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </Input>
              </FormGroup>
            </div>
            <div className="col-md-3">
              <FormGroup>
                <Label>Año de Alta</Label>
                <Input type="select" value={cAnio} onChange={(e) => setCAnio(e.target.value)}
                  style={{ height: 31, fontSize: "0.875rem", padding: "0.25rem 0.5rem", color: "#0f172a" }}>
                  <option value="">Selecciona</option>
                  {["2022","2023","2024","2025","2026","2027","2028","2029","2030","2031"].map((y) => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </Input>
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveCliente}>
            <IcSave style={{ marginRight: 6 }} /> Guardar
          </Button>
          <Button color="secondary" onClick={toggleCreate}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoClientes;
